export { default } from "./readOnlyIndicationContainer";
